import { DirectionsRenderer, GoogleMap } from '@react-google-maps/api';
import React, { useContext } from 'react';
import { ThemeContext } from '../App';

export default function DirectionMapView({ direction }) {
  const isLoaded = useContext(ThemeContext);
  const mapStyles = {
    height: '100%',
    width: '100%'
  };
  const options = {
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
    scaleControl: false,
    keyboardShortcuts: false
  };
  const center = {
    lat: 28.614755250102686,
    lng: 77.20165418747978
  };

  return isLoaded ? (
    <GoogleMap mapContainerStyle={mapStyles} center={center} zoom={15} options={options}>
      {direction && <DirectionsRenderer directions={direction} />}
    </GoogleMap>
  ) : null;
}
